"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _util = require("../util");

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var moreMisc = {
    buttons: ['mergeFields', 'specialCharacters', 'emoticons', 'undo', 'redo', 'selectAll', 'help'],
    buttonsVisible: 5
  };
  return {
    pastePlain: true,
    toolbarInline: true,
    toolbarVisibleWithoutSelection: true,
    toolbarButtons: {
      'moreMisc': options.enableAIGenerator ? (0, _util.addAIGeneratorButton)(moreMisc, 'emoticons') : moreMisc
    },
    multiLine: false,
    events: {
      'paste.beforeCleanup': _util.removeNewlines
    },
    pluginsEnabled: ['emoticons', 'entities', 'specialCharacters', 'customProfileFieldsPlugin'],
    htmlAllowedTags: [''],
    pasteAllowedStyleProps: [],
    helpSets: [{
      title: 'Common actions',
      commands: [{
        val: 'OSkeyC',
        desc: 'Copy'
      }, {
        val: 'OSkeyX',
        desc: 'Cut'
      }, {
        val: 'OSkeyV',
        desc: 'Paste'
      }, {
        val: 'OSkeyZ',
        desc: 'Undo'
      }, {
        val: 'OSkeyShift+Z',
        desc: 'Redo'
      }]
    }, {
      title: 'Basic Formatting',
      commands: [{
        val: 'OSkeyA',
        desc: 'Select All'
      }]
    }]
  };
};

exports.default = _default;